const base32 = require('base-32').default
const uuid = require('uuid/v4')

module.exports = {
  create: function() {
    var buffer = Buffer.alloc(16)
    uuid({}, buffer)
    var encoded = base32.encode(buffer)
    return encoded.replace(/=/g, '')
  },
}
